import React, {useEffect} from "react";

const GenericItem = ({title, details, cssClasses}) => {
    return (
        <div className={`plan-item flexColumn margin-top-1 ${cssClasses}`}>
            <div className={'plan-sub-title'}>
                {title}
            </div>
            <div className={'plan-sub-details'}>
                {details}
            </div>
        </div>
    );
}

export default GenericItem;